import bowser from 'yola-bowser';
import { PANE_ARROW_INDENT, PANE_DEFAULT_INDENT, PANE_SIZE_WITH_LINING } from '../constants/sizes';
import { TEXT_SELECTION_MAX_PANE_ITEMS } from '../constants/pane-items';
import getMaxPaneSize from './get-max-pane-size';
import getDocumentSizes from './get-document-sizes';
import getViewLeftOffset from '../../view/helpers/get-view-left-offset';

const getStyleWithoutUnit = (value) => parseFloat(value).toFixed(4);
const NATIVE_IOS_PANE_HEIGHT = 35;

const getPaneLocationForTextSelection = ({ element, items, scrollPosition, activeWidth = 0 }) => {
  const { windowInnerWidth, windowInnerHeight } = getDocumentSizes();
  const parentWindowWidth = window.innerWidth;
  const { maxPaneWidth, maxPaneHeight } = getMaxPaneSize(
    items,
    parentWindowWidth,
    TEXT_SELECTION_MAX_PANE_ITEMS,
    parentWindowWidth
  );

  const adjustedMaxPaneWidth = Math.max(activeWidth, maxPaneWidth);

  const elementRect = element.getBoundingClientRect();

  const { top, left, width, bottom } = elementRect;

  const styles = element.ownerDocument.defaultView.getComputedStyle(element);
  const fontSize = getStyleWithoutUnit(styles.fontSize);
  const lineHeight =
    styles.lineHeight === 'normal' ? fontSize * 1.14 : getStyleWithoutUnit(styles.lineHeight);
  const textLineHeightIndent = (lineHeight - fontSize) / 2;
  const isIOS = bowser.ios;
  const halfPaneWidth = adjustedMaxPaneWidth / 2;
  const rangeTop = isIOS ? top : top + scrollPosition;
  const rangeBottom = isIOS ? bottom : bottom + scrollPosition;

  let offsetY;
  let offsetX;
  let direction = null;
  let expand;

  offsetX = Number((left + width / 2).toFixed(1));

  const parentWindowOffsetX = offsetX + getViewLeftOffset();

  let arrowOffsetX = adjustedMaxPaneWidth / 2;

  if (rangeTop - PANE_SIZE_WITH_LINING > 0) {
    direction = 'up';
    offsetY = rangeTop - textLineHeightIndent - PANE_ARROW_INDENT - PANE_DEFAULT_INDENT;
  }

  if (
    rangeTop - PANE_SIZE_WITH_LINING > 0 &&
    rangeTop - scrollPosition - PANE_SIZE_WITH_LINING - PANE_DEFAULT_INDENT < 0
  ) {
    direction = 'none';
    offsetY = scrollPosition + PANE_DEFAULT_INDENT;
  }

  if (direction === null && rangeTop - PANE_SIZE_WITH_LINING < 0) {
    direction = 'down';
    offsetY = rangeBottom + textLineHeightIndent + PANE_ARROW_INDENT + PANE_DEFAULT_INDENT;
  }

  if (rangeBottom - scrollPosition < 0 || rangeTop - scrollPosition > windowInnerHeight) {
    direction = null;
  }

  if (
    parentWindowOffsetX < halfPaneWidth &&
    parentWindowOffsetX + halfPaneWidth < parentWindowWidth
  ) {
    if (
      adjustedMaxPaneWidth === parentWindowWidth ||
      adjustedMaxPaneWidth + parentWindowOffsetX > parentWindowWidth
    ) {
      offsetX = windowInnerWidth / 2;
      arrowOffsetX = null;
    } else {
      offsetX = left + halfPaneWidth;
      arrowOffsetX = width / 2;
    }
  } else if (
    parentWindowOffsetX + halfPaneWidth > parentWindowWidth &&
    parentWindowOffsetX - halfPaneWidth > 0
  ) {
    offsetX = left + width - halfPaneWidth;
    arrowOffsetX = adjustedMaxPaneWidth - width / 2;
  }

  if (offsetY - maxPaneHeight < 0) {
    expand = 'down';
  } else {
    expand = 'up';
  }

  // Checking case, when native IOS pane overlaps control-pane below the element. We will hide control pane.
  if (isIOS && direction === 'down' && rangeTop - scrollPosition < NATIVE_IOS_PANE_HEIGHT) {
    direction = null;
  }

  return {
    offsetX,
    offsetY,
    direction,
    expand,
    maxPaneWidth: adjustedMaxPaneWidth,
    arrowOffsetX,
  };
};

export default getPaneLocationForTextSelection;
